import { useMutation } from "@tanstack/react-query";
import { postSubscription } from "api/newsletter.request";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { SubscriptionFormSchemaType } from "../util/subscriptionForm";
import { HCatchServerError } from "@helpers/cath-error-server";

const initialState = {
  body: "",
  title: "",
  isError: false,
};

type State = typeof initialState;
const postData = async (values: SubscriptionFormSchemaType) => {
  const response = await postSubscription(values);
  return response;
};
export const useSubscriptionForm = () => {
  const [message, setMessage] = useState<State>(initialState);
  const [isOpen, setIsOpen] = useState(false);
  const translationAlert = useTranslations("alerts.subscription");

  const handleMessage = (data: State) => {
    setMessage(data);
    setIsOpen(true);
  };

  const { mutateAsync, isLoading } = useMutation(postData, {
    onSuccess: (data) => {
      handleMessage({
        title: translationAlert("titleSuccess"),
        body: data?.message || "",
        isError: false,
      });
    },
    onError: (e: any) => {
      const title = translationAlert("titleError");
      handleMessage({
        title: title,
        body: HCatchServerError(e.response.data),
        isError: true,
      });
    },
  });

  return { mutateAsync, isLoading, message, isOpen, setIsOpen };
};
